import { max, parseISO } from "@otrl/ui/lib/date";
import debugHook from "@otrl/ui/hooks/hookUtils";
import useStableCallback from "@otrl/ui/hooks/useStableCallback";
import useConfig from "./useConfig";
import useModal from "./useModal";


import { getHandoffUrl } from "helpers/handoff";
import { RecentOrderModal } from "../components/recentOrders/RecentOrderModal";

export default debugHook(useHandoff, "useHandoff");

function useHandoff() {
  const {
    bookingEngineUrl,
    brand,
    handoffInNewWindow,
    flexiStartDate = new Date().toISOString(),
  } = useConfig();
  const { closeModal, showModal } = useModal();

  const redirect = (url) => {
    const target = handoffInNewWindow ? "_blank" : "_top";
    window.open(url, target);
  }

  return useStableCallback((fare) => {
    function onHandoff(fare, startDate) {

      const handOffUrl = getHandoffUrl({
        brand,
        bookingEngineUrl,
        fare,
        startDate,
      });

      redirect(handOffUrl);
    }

    const minDate = fare.ticketType?.isFlexi
      ? max([new Date(), parseISO(flexiStartDate)])
      : new Date();

    showModal(
      <RecentOrderModal
          minDate={minDate}
          onHandoff={onHandoff}
          fare={fare}
          closeModal={closeModal}
      />,
      {
        autoFocus: false,
        takeoverTablet: true,
        classNames: {
          bodyClassName: 'otrl-jp__global-modal__recent-order-body'
        }
      }
    );
  });
}
